/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Import Team Project" |
*
* @param {Team_Project_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_title = /** @type {((inputs?: Team_Project_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer un projet d’équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importteam-Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa progetto di squadra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект импортной команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto de equipo de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入团队项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात टीम परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto da Equipe de Importação")
	return /** @type {LocalizedString} */ ("Import Team Project")
});